import React, {useEffect, useState, useContext} from 'react';
import { GatewayBillingService } from 'gw-capability-gateway-billing';
import { UserService} from 'gw-capability-gateway';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import metadata from './BrokerBills.metadata.json5';
import { Link as LinkComponent} from '@jutro/components';
import { formatDate } from '@jutro/components';
import { IntlContext } from '@jutro/locale';
import { GatewayDocumentService } from 'gw-capability-gateway-document';

function BrokerBills(props){
    const {authHeader} = props;
    const [brokerBills, updateBrokerBills] = useState([]);
    const intl = useContext(IntlContext);

    useEffect(() => {
        UserService.getAvailableProducerCodesForCurrentUserByPermission('brokerBillView_EY', authHeader).then((producerCodes)=>{            
            if(producerCodes.length > 0){
                var producerCodeList = producerCodes.map((producerCode)=>{return producerCode.code})
                GatewayBillingService.getBillingDocumentsForBroker(producerCodeList, authHeader).then((response) => {
                    const docList = response.map((doc) => {
                        //const downloadLink = GatewayDocumentService.downloadBillingDocument(doc.publicID, doc.sessionID)
                        const downloadLink = `${window.location.origin}/producer-engage/document/gatewaybilling/document/${doc.publicID}?token=${doc.sessionID}&isBrokerBills=true`;
                        doc['downloadLink'] = downloadLink;
                        //`/document/gatewaybilling/document/${doc.publicID}?token=${doc.sessionID}&isBrokerBills=true&portalRoute=/ProducerEngage/html/GatewayDocumentError`
                        return doc
                    });
                    updateBrokerBills(docList)
                })
            }
            
        });
    }, []);

    

    const getDownloadLink = (rowData) => {
        return <LinkComponent target="_blank" href={rowData['downloadLink']}>{rowData.name}</LinkComponent>
    }

    const getModifiedDate = (rowData) => {
        return formatDate(intl, { }, new Date(rowData.dateModified))
    }


    const overrides = {
        brokerBillsTable: {
            data: brokerBills
        }
    };
    const resolvers = {
        resolveCallbackMap: {
            getDownloadLink: getDownloadLink,
            getModifiedDate: getModifiedDate
        }
    };

    const brokerBillsPage = renderContentFromMetadata(metadata.pageContent, overrides, resolvers);



    return <div>{brokerBillsPage}</div>

}

export default withAuthenticationContext(BrokerBills)